"use client";

import { motion } from "framer-motion";
import { CircleCheckBig, RefreshCw } from "lucide-react";
import { getViewModeChrome } from "../view-mode-chrome";

interface RestartNotebookSuccessProps {
  result?: any;
  viewMode?: string;
}

export function RestartNotebookSuccess({
  result,
  viewMode,
}: RestartNotebookSuccessProps) {
  const chrome = getViewModeChrome(viewMode);
  const previousCellCount = result?.previous_cell_count ?? 0;
  const remainingCellCount = result?.remaining_cell_count ?? 1;

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.98 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.2, ease: "easeOut" }}
      className="w-full"
    >
      <div className={`rounded-md border ${chrome.card} overflow-hidden`}>
        <div className="flex items-center justify-between px-3 py-2 gap-3">
          <div className="flex items-start gap-2.5 min-w-0">
            <RefreshCw className={`w-3.5 h-3.5 ${chrome.iconMuted} shrink-0`} strokeWidth={2} />

            <div className="flex min-w-0 flex-col">
              <span className={`text-[13px] font-semibold ${chrome.text} truncate`}>
                Notebook restarted
              </span>
              <span className={`text-[11px] ${chrome.subtext} truncate`}>
                {previousCellCount > 0
                  ? `${Math.max(previousCellCount - remainingCellCount, 0)} cell(s) cleared`
                  : "Environment reset"}
              </span>
            </div>
          </div>

          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ delay: 0.1, type: "spring", stiffness: 300 }}
          >
            <CircleCheckBig className="h-4 w-4 text-green-500" />
          </motion.div>
        </div>
      </div>
    </motion.div>
  );
}
